import React from 'react';
import { GroupElement, ImageElement, ShapeElement, TextElement, VideoElement } from '@bynder-studio/render-web';
import { Form, InteractiveIcon } from '@bynder/design-system';
import { IconLockOpenSmall, IconLockSmall } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';
import { useEffectivelyLocked } from 'packages/hooks/useEffectivelyLocked';
import generateTestId from 'packages/helpers/testIdHelpers';

const lockRatioTestId = generateTestId('shots_properties_lock_ratio');

type Props = {
    selectedElement: TextElement | ImageElement | ShapeElement | GroupElement | VideoElement;
    forceUpdate: () => void;
};

const LockToggler = ({ selectedElement, forceUpdate }: Props) => {
    const { translate } = useTranslate();
    const locked = useEffectivelyLocked();

    const isGroup = selectedElement instanceof GroupElement;
    const value = isGroup || selectedElement.lockUniScaling;

    const handleChangeLockUniScaling = () => {
        // update prop on element, originally we don't store this prop on element
        selectedElement.lockUniScaling = !selectedElement.lockUniScaling;
        forceUpdate();
    };

    return (
        <Form.Group>
            <InteractiveIcon
                label={translate('editor.sidebar.shots.width.lock.label')}
                onClick={() => !isGroup && handleChangeLockUniScaling()}
                icon={value ? <IconLockSmall /> : <IconLockOpenSmall />}
                isDisabled={locked || isGroup}
                {...lockRatioTestId}
            />
        </Form.Group>
    );
};

export default LockToggler;
